import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools } from "zustand/middleware";

export const conversacaoInitialState = {
  conversacaoId: "",
  stage: "",
  metadata: {},
  historico: [],
};

export const useConversacaoStore = create()(
  devtools(
    immer((set) => ({
      ...conversacaoInitialState,
      setConversacaoId(id) {
        set((state) => { state.conversacaoId = id; }, true, "setConversacaoId");
      },
      setStage(stage) {
        set((state) => { state.stage = stage; }, true, "setStage");
      },
      setMetadata(metadata) {
        set((state) => { state.metadata = metadata; }, true, "setMetadata");
      },
      addHistorico(entry) {
        set((state) => { state.historico = [...state.historico, entry]; }, true, "addHistorico");
      },
      setConversacao(conversacao) {
        set((state) => {
          state.conversacaoId = conversacao.id ?? state.conversacaoId;
          state.stage = conversacao.stage ?? state.stage;
          state.metadata = conversacao.metadata ?? state.metadata;
          state.historico = conversacao.historico ?? state.historico;
        }, true, "setConversacao");
      },
    })),
    { enabled: true, name: "useConversacaoStore" }
  )
);

export default useConversacaoStore;
